export const navBarData = [
  { id: 1, tittle: "Timeline" },
  { id: 2, tittle: "About" },
  { id: 5, userProfile: true },
  { id: 3, tittle: "Friends" },
  { id: 4, tittle: "Photos" },
];

export const socialGroupData = [
  { imageName: "2.jpg", userName: "Johny Waston" },
  { imageName: "3.jpg", userName: "Andew Jon" },
  { imageName: "4.jpg", userName: "Comeren Diaz" },
  { imageName: "5.jpg", userName: "Bucky Barnes" },
  { imageName: "6.jpg", userName: "Jason Borne" },
  { imageName: "7.jpg", userName: "Comeren Diaz" },
];

export const mutualFriendData = [
  {
    id: 1,
    imageName: "1.jpg",
    title: "Bucky Barnes",
    email: "winter@gmail.com",
    socialClass: "social-online",
  },
  {
    id: 2,
    imageName: "2.jpg",
    title: "Sarah Loren",
    email: "barnes@gmail.com",
    socialClass: "social-busy",
  },
  {
    id: 3,
    imageName: "3.jpg",
    title: "Jason Borne",
    email: "jasonb@gmail.com",
    socialClass: "social-offline",
  },
  {
    id: 4,
    imageName: "4.jpg",
    title: "Comeren Diaz",
    email: "comere@gmail.com",
    socialClass: "social-offline",
  },
  {
    id: 5,
    imageName: "5.jpg",
    title: "Andew Jon",
    email: "andrewj@gmail.com",
    socialClass: "social-online",
  },
  {
    id: 6,
    imageName: "6.jpg",
    title: "Johny Waston",
    email: "johny@gmail.com",
    socialClass: "social-busy",
  },
  {
    id: 7,
    imageName: "7.jpg",
    title: "Johny William",
    email: "johnyw@gmail.com",
    socialClass: "social-offline",
  },
  {
    id: 8,
    imageName: "8.jpg",
    title: "Bucky Barnes",
    email: "winter@gmail.com",
    socialClass: "social-online",
  },
  {
    id: 9,
    imageName: "9.jpg",
    title: "Sarah Loren",
    email: "barnes@gmail.com",
    socialClass: "social-busy",
  },
  {
    id: 10,
    imageName: "1.jpg",
    title: "Jason Borne",
    email: "jasonb@gmail.com",
    socialClass: "social-offline",
  },
  {
    id: 11,
    imageName: "2.jpg",
    title: "Comeren Diaz",
    email: "comere@gmail.com",
    socialClass: "social-offline",
  },
  {
    id: 12,
    imageName: "3.jpg",
    title: "Andew Jon",
    email: "andrewj@gmail.com",
    socialClass: "social-online",
  },
  {
    id: 13,
    imageName: "4.jpg",
    title: "Johny Waston",
    email: "johny@gmail.com",
    socialClass: "social-busy",
  },
  {
    id: 14,
    imageName: "5.jpg",
    title: "Johny William",
    email: "johnyw@gmail.com",
    socialClass: "social-offline",
  },
];

export const friendsData = [
  {
    time: "20 min",
    imageName: "1.jpg",
    title: "Jason Borne",
  },
  {
    time: "1 hour ",
    imageName: "2.jpg",
    title: "Anna Mull",
  },
  {
    time: "1 days",
    imageName: "3.jpg",
    title: "Dion Cast",
  },
  {
    time: "1 days",
    imageName: "4.jpg",
    title: "Karlene Lex",
  },
  {
    time: "5 days",
    imageName: "5.jpg",
    title: "Vella Chism",
  },
  {
    time: "6 days",
    imageName: "6.jpg",
    title: "Wai Schalk",
  },
];

export const galleryGridImages = [
  "big-lightgallery/1.jpg",
  "big-lightgallery/2.jpg",
  "big-lightgallery/3.jpg",
  "big-lightgallery/4.jpg",
  "big-lightgallery/5.jpg",
  "big-lightgallery/6.jpg",
  "big-lightgallery/7.jpg",
  "big-lightgallery/8.jpg",
  "big-lightgallery/9.jpg",
  "big-lightgallery/10.jpg",
  "big-lightgallery/11.jpg",
  "big-lightgallery/12.jpg",
];

export const userContentData = [
  {
    img: "social-app/timeline-1.png",
    name: "ELANA",
    date: "January, 12,2019",
    icon: "more-vertical",
    img2: "social-app/timeline-1.png",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse sed urna in justo euismod condimentum. Fusce placerat enim et odio molestie sagittis.",
    socialChatData: [
      {
        class: "your-msg",
        img: "1.jpg",
        name: "Jason Borne",
        time: "1 year Ago",
        chat: "we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post",
      },
      {
        class: "other-msg",
        img: "2.jpg",
        name: "Alexendra Dhadio",
        time: "1 Month Ago",
        chat: "yes, really very awesome car i see the features of this car in the official website of #Mercedes-Benz and really impressed :-",
      },
      {
        class: "other-msg",
        img: "3.jpg",
        name: "Olivia Jon",
        time: "15 Days Ago",
        chat: "i like lexus cars, lexus cars are most beautiful with the awesome features, but this car is really outstanding than lexus",
      },
      {
        class: "your-msg",
        img: "4.jpg",
        name: "Issa Bell",
        time: "1 year Ago",
        chat: "we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post",
      },
    ],
  },
  {
    img: "social-app/timeline-2.png",
    name: "ELANA",
    date: "January, 12,2019",
    icon: "more-vertical",
    img2: "social-app/timeline-2.png",
    description:
      "I've always thought of the T-shirt as the Alpha of the fashion alphabet. My breakfast is very important. Everything I do is a matter of heart, body and soul. The only way to do something in depth is to work hard.",
    socialChatData: [
      {
        class: "your-msg",
        img: "1.jpg",
        name: "Jason Borne",
        time: "1 year Ago",
        chat: "we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post",
      },
      {
        class: "your-msg",
        img: "2.jpg",
        name: "Issa Bell",
        time: "1 year Ago",
        chat: "we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post",
      },
    ],
  },
];

export const profileIntroData = [
  {
    tittle: "About Me",
    paragraph:
      "Hi, I’m elana, I’m 30 and I work as a web Designer for the “Daydreams”  Agency in Pier 56.",
  },
  {
    tittle: "Favorite TV shows",
    paragraph:
      "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.",
  },
  {
    tittle: "Favorite Music Bands",
    paragraph:
      "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.",
  },
];

export const followersData = [
  {
    id: 1,
    imageName: "4.jpg",
    name: "Bucky Barnes",
  },
  {
    id: 2,
    imageName: "5.jpg",
    name: "Sarah Loren",
  },
  {
    id: 3,
    imageName: "6.jpg",
    name: "Jason Borne",
  },
  {
    id: 4,
    imageName: "7.jpg",
    name: "Comeren Diaz",
  },
  {
    id: 5,
    imageName: "8.jpg",
    name: "Andew Jon",
  },
];

export const followingsData = [
  {
    id: 1,
    imageName: "9.jpg",
    name: "Sarah Loren",
  },
  {
    id: 2,
    imageName: "1.jpg",
    name: "Bucky Barnes",
  },
  {
    id: 3,
    imageName: "2.jpg",
    name: "Comeren Diaz",
  },
  {
    id: 4,
    imageName: "3.jpg",
    name: "Jason Borne",
  },
  {
    id: 5,
    imageName: "4.jpg",
    name: "Andew Jon",
  },
];

export const numbers = [1, 2, 3, 4, 5, 6, 7, 8];

export const friendsImageName = [
  "3.jpg",
  "5.jpg",
  "1.jpg",
  "2.jpg",
  "3.jpg",
  "6.jpg",
  "1.jpg",
  "10.jpg",
  "1.jpg",
  "4.jpg",
  "11.jpg",
  "8.jpg",
];

export const peopleYouMayKnowData = [
  { peopleName: "Jason Borne", peopleImageName: "avatar/9.jpg" },
  { peopleName: "Anna Mull", peopleImageName: "avatar/8.jpg" },
  { peopleName: "Dion Cast", peopleImageName: "avatar/7.jpg" },
  { peopleName: "Karlene Lex", peopleImageName: "avatar/6.jpg" },
  { peopleName: "Vella Chism", peopleImageName: "avatar/5.jpg" },
  { peopleName: "Wai Schalk", peopleImageName: "avatar/4.jpg" },
  { peopleName: "Karlene Lex", peopleImageName: "avatar/3.jpg" },
];
export const hobbiesAndInterestsData = [
  {
    heading1: "Hobbies",
    heading2: "Favourite Music Bands / Artists",
    paragraph1:
      "I like to ride the bike to work, swimming, and working out. I also like reading design magazines, go to museums, and binge watching a good tv show while it’s raining outside.",
    paragraph2:
      "Iron Maid, DC/AC, Megablow, The Ill, Kung Fighters, System of a Revenge.",
  },
  {
    heading1: "Favorite TV shows",
    heading2: "Favourite Books",
    paragraph1:
      "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.",
    paragraph2:
      "The Crime of the Century, Egiptian Mythology 101, The Scarred Wizard, Lord of the Wings, Amongst Gods, The Oracle, A Tale of Air and Water.",
  },
  {
    heading1: "Favourite Movies",
    heading2: "Favourite Writers:",
    paragraph1:
      "Idiocratic, The Scarred Wizard and the Fire Crown, Crime Squad Ferrum Man.",
    paragraph2:
      "Martin T. Georgeston, Jhonathan R. Token, Ivana Rowle, Alexandr Platt, Marcus Roth.",
  },
  {
    heading1: "Favourite Games:",
    heading2: "Other Interests:",
    paragraph1:
      "The First of Us, Assassin’s Squad, Dark Assylum, NMAK16, Last Cause 4, Grand Snatch Auto.",
    paragraph2:
      "Swimming, Surfing, SCion Diving, Anime, Photography, Tattoos, Street Art.",
  },
];

export const educationAndEmploymentData = [
  {
    heading1: "The New College of Design",
    heading2: "Digital Design Intern",
    date1: "2001-2006",
    date2: "2006-2008",
    paragraph1:
      "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.",
    paragraph2:
      "Digital Design Intern for the “Multimedz” agency. Was in charge of the communication with the clients.",
  },
  {
    date1: "2008",
    date2: "2001-2006",
    heading1: "Rembrandt Institute",
    heading2: "UI/UX Designer",
    paragraph1:
      "Five months Digital Illustration course. Professor: Leonardo Stagg.",
    paragraph2:
      "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.",
  },
  {
    date1: "2010",
    date2: "2008-2013",
    heading1: "The Digital College",
    heading2: "The New College of Design",
    paragraph1:
      "6 months intensive Motion Graphics course. After Effects and Premire. Professor: Donatello Urtle.",
    paragraph2: "UI/UX Designer for the “Daydreams” agency.",
  },
];

export const activityLogData = [
  {
    id: 1,
    icon: "thumbs-up",
    description: "Comeren Diaz likes your photos.",
  },
  {
    id: 2,
    icon: "user-plus",
    description: "Karlene Lex and Comeren Diaz now friends.",
  },
  {
    id: 3,
    icon: "message-square",
    description: "Sarah Loren wrote on your timeline",
  },
  {
    id: 4,
    icon: "thumbs-up",
    description: `Johny Waston likes your post's.`,
  },
  {
    id: 5,
    icon: "user-plus",
    description: "Andew Jon became friends with Comeren Diaz.",
  },
  {
    id: 6,
    icon: "user-plus",
    description: "Johny Waston became friends with Bucky Barnes.",
  },
];

export const userCardData = [
  {
    id: 1,
    avatar: "avatar/1.jpg",
    icon: "check-circle",
    name: "Brooklyn Simmons",
    email: "@brookly.simmons",
    totalPost: "1,908",
    follower: "34.0k",
    following: "897",
  },
  {
    id: 2,
    avatar: "avatar/2.jpg",
    icon: "check-circle",
    name: "Mark Jecno",
    email: "@mark.jeco",
    totalPost: "875",
    follower: "12.0k",
    following: "1400",
  },
  {
    id: 3,
    avatar: "avatar/3.jpg",
    icon: "check-circle",
    name: "Dev John",
    email: "@john.dev",
    totalPost: "1,274",
    follower: "15.0k",
    following: "1874",
  },
  {
    id: 4,
    avatar: "avatar/4.jpg",
    icon: "check-circle",
    name: "Johan Deo",
    email: "@deo.johan",
    totalPost: "500",
    follower: "8.0k",
    following: "570",
  },
  {
    id: 5,
    avatar: "avatar/5.jpg",
    icon: "check-circle",
    name: "Douglas Reichel",
    email: "@reichel.douglas",
    totalPost: "460",
    follower: "2k",
    following: "350",
  },
  {
    id: 6,
    avatar: "avatar/6.jpg",
    icon: "check-circle",
    name: "Lisa lillian",
    email: "@lisa.lillian",
    totalPost: "547",
    follower: "3.5k",
    following: "822",
  },
  {
    id: 7,
    avatar: "avatar/7.jpg",
    icon: "check-circle",
    name: "Olivia rose",
    email: "@rose.olivia",
    totalPost: "868",
    follower: "1k",
    following: "742",
  },
  {
    id: 8,
    avatar: "avatar/8.jpg",
    icon: "check-circle",
    name: "Sarah Karen",
    email: "@karen.sarah",
    totalPost: "972",
    follower: "2.5k",
    following: "864",
  },
];
export const photosTabData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const tourProfileData = [
  {
    link: "https://www.facebook.com/",
    icon: "fa fa-facebook",
  },
  {
    link: "https://accounts.google.com/",
    icon: "fa fa-google-plus",
  },
  {
    link: "https://twitter.com/",
    icon: "fa fa-twitter",
  },
  {
    link: "https://www.instagram.com/",
    icon: "fa fa-instagram",
  },
  {
    link: "https://rss.app/",
    icon: "fa fa-rss",
  },
];
